import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { fetchMyTickets } from '../api/endpoints';
import { formatDateTime } from '../lib/format';
import { useUserStore } from '../store/userStore';
import TopBar from '../components/TopBar';
import Splash from '../components/Splash';

export default function MyTickets() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = useUserStore((s) => s.lang);
  const { data, isLoading } = useQuery({ queryKey: ['my-tickets'], queryFn: fetchMyTickets });

  if (isLoading) return <Splash />;

  const statusKey: Record<string, string> = {
    PAID: t('tickets.statusPaid'),
    USED: t('tickets.statusUsed'),
    REFUNDED: t('tickets.statusRefunded'),
    CANCELED: t('tickets.statusCanceled'),
    HELD: t('tickets.statusHeld'),
    PAID_PENDING: t('tickets.statusPendingPayment'),
  };
  const statusColor: Record<string, string> = {
    PAID: 'text-success',
    USED: 'text-muted',
    REFUNDED: 'text-danger',
    CANCELED: 'text-danger',
    HELD: 'text-warn',
    PAID_PENDING: 'text-warn',
  };

  return (
    <div className="min-h-screen pb-8">
      <TopBar title={t('tickets.title')} />
      <div className="px-4 pt-3 space-y-2">
        {data?.length ? (
          data.map((t) => {
            const needsPayment = t.status === 'HELD' || t.status === 'PAID_PENDING';
            return (
              <div key={t.id} className="card p-3.5">
                <div className="flex items-start justify-between gap-3">
                  <div className="min-w-0">
                    <div className="font-semibold truncate">{t.session_title}</div>
                    <div className="text-xs text-muted mt-0.5">{t.cinema_name}</div>
                    <div className="text-xs text-muted mt-0.5">{formatDateTime(t.session_starts_at, lang)}</div>
                    <div className="text-sm mt-1.5">
                      {t.sector_name} · ряд {t.row_num}, место {t.seat_num}
                    </div>
                  </div>
                  <div className={`text-xs font-semibold ${statusColor[t.status] || ''}`}>
                    {statusKey[t.status] || t.status}
                  </div>
                </div>
                {needsPayment && t.order_id != null && (
                  <button
                    onClick={() => navigate(`/payment/${t.order_id}`)}
                    className="mt-3 w-full py-2 rounded-xl bg-accent text-sm font-semibold active:opacity-80"
                  >
                    {t.status === 'HELD'
                      ? 'Перейти к оплате →'
                      : 'Открыть статус оплаты →'}
                  </button>
                )}
              </div>
            );
          })
        ) : (
          <div className="text-muted text-center py-12">{t('tickets.empty')}</div>
        )}
      </div>
    </div>
  );
}
